import { professionalSelectionSearchManager } from './professionalSelectionSearch/professionalSelectionSearch.manager'
import { professionalSelectionHistoryManager } from './professionalSelectionHistory/professionalSelectionHistory.manager'

export const professionalSelectionManager = {
  ...professionalSelectionSearchManager,
  ...professionalSelectionHistoryManager,
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/professionalSelection/professionalSelection.manager.ts